import { Region } from 'constants/shop';

/**
 * Resolve the shop region from a url by its top-level domain.
 */
export const getRegion = (url?: string): Region => {
  if (!url) return Region.DE;

  try {
    const { hostname } = new URL(url.includes('://') ? url : `https://${url}`);
    if (hostname.toLowerCase().endsWith('.ch')) return Region.CH;
    if (hostname.toLowerCase().endsWith('.nl')) return Region.NL;
  } catch {
    // Invalid URL-like input falls back to the default German region.
  }

  return Region.DE;
};
